import { Modal } from 'react-native'
import React from 'react'
import SharePreview from './SharePreview'

interface SharePreviewModalProps {
    visible: boolean
    onPressClose: () => void
}

const SharePreviewModal: React.FC<SharePreviewModalProps> = ({ visible, onPressClose }) => {
  return (
    <Modal
        animationType="fade"
        transparent={true}
        visible={visible}
        style={{flex: 1}}
    >
        <SharePreview onPressClose={onPressClose} />
    </Modal>
  )
}

export default SharePreviewModal